export const OSM_TILE_URL =
  import.meta.env.VITE_OSM_TILE_URL || "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

export const OSM_TILE_ATTRIBUTION =
  import.meta.env.VITE_OSM_TILE_ATTRIBUTION ||
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export function isOsmShopMapsEnabled(): boolean {
  const raw = (import.meta.env.VITE_ENABLE_OSM_SHOP_MAPS || "true").toString().toLowerCase();
  return raw !== "false" && raw !== "0" && raw !== "off";
}
